<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="50%"
    top="60px"
    :fullscreen="dialogFull"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :before-close="handleClose"
    append-to-body
    :modal-append-to-body="false"
  >
    <template slot="title">
      <div class="avue-crud__dialog__header">
        <span class="el-dialog__title"> 查看车辆 </span>
        <i
          class="el-icon-full-screen"
          style="margin-right: 20px; position: relative; top: -1px"
          @click="dialogFull = !dialogFull"
        ></i>
      </div>
    </template>
    <div style="max-height: calc(100vh - 300px); overflow: scroll">
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        :permission="permissionList"
        :before-open="beforeOpen"
        :before-close="handleClose"
        v-model="form"
        ref="crud"
        @row-update="rowUpdate"
        @row-save="rowSave"
        @row-del="rowDel"
        @search-change="searchChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        @on-load="onLoad"
        @refresh-change="onLoad"
      >
        <template slot="menuLeft">
          <el-button
            type="danger"
            size="small"
            v-if="permissionList.delBtn"
            @click="rowDelAll"
            icon="el-icon-delete"
            >删除</el-button
          >
        </template>
      </avue-crud>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import { parkGroupPage as getList, parkGroupRemove as remove } from '@/api/v4ward/carv2/cargroup';
export default {
  data() {
    return {
      loading: false,
      carParkGroupName: '',
      disabled: false,
      form: {
        list: [],
      },
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      dialogVisible: false,
      dialogFull: false,
      option: {
        height: 'auto',
        calcHeight: 50,
        tip: true,
        border: true,
        index: true,
        selection: true,
        columnBtn: true,
        refreshBtn: true,
        searchBtn: true,
        delBtn: true,
        addBtn: false,
        viewBtn: false,
        editBtn: false,
        searchMenuSpan: 18,
        column: [
          {
            label: '车位组名称',
            prop: 'carParkGroupName',
          },
          {
            label: '车牌号',
            prop: 'plateNumber',
            type: 'input',
            search: true,
          },
        ],
      },
      parkGroupId: '',
      spaceId: '',
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        delBtn: this.vaildData(this.permission.carGroupCars_delete, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.option.height = this.bodyHeight - 550;
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.crud.$refs.table.doLayout();
      }, 500);
    });
  },
  methods: {
    openDialog(row) {
      console.log(row);
      this.carParkGroupName = row.carParkGroupName;
      this.parkGroupId = row.id;
      this.spaceId = row.parkingLotId;
      this.dialogVisible = true;
      this.onLoad();
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.crud.$refs.table.doLayout();
        }, 500);
      });
    },
    submit(form, down) {
      console.log(form);
      this.disabled = true;
      setTimeout(() => {
        this.disabled = false;
        down();
      }, 2000);
    },
    formSubmit1() {
      this.$refs.form.submit();
    },
    rowDelAll() {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    // 弹窗关闭前
    handleClose(done) {
      // let self = this;
      // this.$confirm('确认关闭?', '提示', {
      //         confirmButtonText: '确定',
      //         cancelButtonText: '取消',
      //         type: 'warning',
      // })
      // .then(()=> {

      this.dialogVisible = false;

      // })
      // .catch(()=> {

      // });
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      this.query.parkGroupId = this.parkGroupId;
      this.query.spaceId = this.spaceId;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>
